import React, { useState } from "react";
import { get } from "lodash";
import { Field } from "redux-form";
import { useParams } from "react-router-dom";
import { required, email, confirmation, length } from "redux-form-validators";

import { scrollToTop } from "../../../../helpers/animation";
import { Button, Checkbox, Input } from "../../../../components/Field";
import { getPasswordValidationRegex } from "../../../../../src/helpers/input";
import PlanList from "./PlanList";
import Link from "../../../../components/Link";
import Text from "../../../../components/Text";
import AsyncForm from "../../../../components/AsyncForm";

import style from "../style.module.css";

export default function PersonalDetails({ nextStep, personalDetails = {}, setPersonalDetails, setPlanId, setPlanType }) {
    const Params = useParams();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [userPlan, setUserPlan] = useState(null);
    const [urlplan, setUrlPlan] = useState(get(Params, 'plan', ''));
    
    return (
        <div className={style.personalDetails}>
            <AsyncForm
                id="step01"
                url="/account/register"
                permission={false}
                showToastOnSuccess={false}
                onSave={({ data }) => {
                    setPersonalDetails(data);
                    nextStep('OTP');
                    scrollToTop();
                }}
                initialValues={
                    {
                        email: personalDetails.email !== undefined ? personalDetails.email : "",
                        first_name: personalDetails.first_name !== undefined ? personalDetails.first_name : "",
                        surname: personalDetails.surname !== undefined ? personalDetails.surname : "",
                        terms: personalDetails.terms !== undefined ? personalDetails.terms : "",
                        marketing_opt_in: personalDetails.marketing_opt_in !== undefined ? personalDetails.marketing_opt_in : "",
                        plan_id: get(Params, 'plan', ''),
                        subscribe: 1,
                    }
                }
                render={({ fetching, formValues, change }) => {
                    return (
                        <div className={style.form}>
                            <div className={style.formRow}>
                                <Text className="formTitle" text="CHoose a Membership plan" />
                                <Text className="formSubTitle" text="Select membership type*" />
                            </div>
                            <div className={style.formRow}>
                                <PlanList
                                    urlplan={urlplan}
                                    setUrlPlan={setUrlPlan}
                                    userplan={userPlan}
                                    setuserplan={setUserPlan}
                                    setPlanId={setPlanId}
                                    setPlanType={setPlanType}
                                />
                            </div>
                            <div className={style.formRow}>
                                <Text className="formTitle" text="enter personal DETAILS" />
                            </div>
                            <div className={style.formRow}>
                                <Field
                                    name="first_name"
                                    component={Input}
                                    validate={required()}
                                    required={true}
                                    placeholder="Enter your first name"
                                    label="First name"
                                />
                            </div>
                            <div className={style.formRow}>
                                <Field
                                    name="surname"
                                    component={Input}
                                    validate={required()}
                                    label="Surname"
                                    required={true}
                                    placeholder="Enter your surname"
                                />
                            </div>
                            <div className={`${style.formRow} ${style.bottomBorder}`}>
                                <Field
                                    name="email"
                                    component={Input}
                                    validate={[required(), email()]}
                                    label="Email address"
                                    required={true}
                                    placeholder="Enter email address"
                                />
                            </div>
                            <div className={style.formRow}>
                                <Text className="formTitle" text="create your unique password" />
                            </div>
                            <div className={style.formRow}>
                                <div className={style.formFieldRow}>
                                    <Field
                                        name="password"
                                        type={showPassword ? "text" : "password"}
                                        component={Input}
                                        validate={[required(), length({ minimum: 12 }), getPasswordValidationRegex()]}
                                        placeholder="New Password"
                                        label="Create password"
                                        required={true}
                                    />
                                    <Link
                                        className={style.show} onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? "Hide" : "Show"}
                                        <span className={`${style.dropDown} ${style.right}`}></span>
                                    </Link>
                                </div>
                            </div>
                            <div className={style.formRow}>
                                <div className={style.formFieldRow}>
                                    <Field
                                        name="confirm_password"
                                        type={showConfirm ? "text" : "password"}
                                        component={Input}
                                        validate={[required(), confirmation({ field: 'password' })]}
                                        placeholder="Confirm Password"
                                        label="Confirm password"
                                        required={true}
                                    />
                                    <Link
                                        className={style.show} onClick={() => setShowConfirm(!showConfirm)}
                                    >
                                        {showConfirm ? "Hide" : "Show"}
                                        <span className={`${style.dropDown} ${style.right}`}></span>
                                    </Link>
                                </div>
                            </div>
                            <div className={`${style.formRow} ${style.checkBoxRow}`}>
                                <Field
                                    name="terms"
                                    component={Checkbox}
                                    checkValue={1}
                                    validate={required()}
                                    link="terms-conditions"
                                    label="I agree to"
                                />
                                <Link
                                    className={style.termsLink}
                                    target="_blank"
                                    to={"terms-conditions"}
                                >
                                    {"terms & conditions"}
                                </Link>*
                            </div>
                            <div className={style.formRow}>
                                <Field
                                    name="marketing_opt_in"
                                    component={Checkbox}
                                    checkValue={1}
                                    unCheckedValue={0}
                                    label="I agree to opt in for marketing purposes"
                                    onChange={(newValue, field) => {
                                        change("subscribe", newValue === 1 ? 1 : 0);
                                    }}
                                />
                            </div>
                            {
                                get(formValues, 'marketing_opt_in', 0) === 1 && (
                                    <div className={style.formRow}>
                                        <Field
                                            name="subscribe"
                                            component={Checkbox}
                                            checkValue={1}
                                            unCheckedValue={0}
                                            label="Subscribe to the ww2HQ Newsletter"
                                        />
                                    </div>
                                )
                            }
                            <div className={`${style.formRow} ${style.formSubmit}`}>
                                <Button
                                    submit={true}
                                    fetching={fetching}
                                    label="NEXT"
                                />
                            </div>
                        </div>
                    )
                }}
            />
        </div>
    )
}